<template>
  <div class="auth-wrapper">
    <header v-if="!isWmsSystem">
      <div class="logos">
        <!-- <img src="@/assets/img/logo1.png">
        <span class="logo-title">
          运荔枝货主版
        </span> -->
        <img src="@/assets/img/title.png" alt="">
      </div>
      <div class="menu">
        <div class="list"
             @click="$router.push('/login')">
          <img class="list-img"
               src="@/assets/img/menu-order.png">
          在线下单
        </div>
        <div class="list active">
          <img class="list-img"
               src="@/assets/img/menu-house.png">
          我要寻仓
        </div>
      </div>
    </header>
    <div class="auth-container">
      <router-view></router-view>
      <copy-right />
    </div>
  </div>
</template> 

<script>
// import Warehouse from './index.vue'
// import Detail from './detail.vue'
import CopyRight from './component/Copyright.vue'

export default {
  components: {
    // Warehouse,
    // Detail,
    CopyRight,
  },
  data() {
    return {}
  },
  computed:{
    isWmsSystem(){
      const {source} = this.$route.query;
      return source==='WMS'
    }
  },
}
</script>


<style lang="less" scoped>
.auth-wrapper {
  display: flex;
  flex-direction: column;
  align-content: center;
  width: 100%;
  min-height: 100vh;
  background: #F4F5F6;
  header {
    display: flex;
    align-items: flex-end;
    box-shadow: 0px 1px 6px -1px #ccc;
    background: #fff;
    height: 108px;
    padding: 0 60px;
    align-items: center;
    .logos {
      img {
        width: 200px;
        height: 56px;
      }
    }
    .menu {
      position: absolute;
      top: 0px;
      right: 220px;
      display: flex;
      .list {
        height: 100%;
        line-height: 108px;
        cursor: pointer;
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #606266;
        &:first-of-type {
          margin-right: 131px;
        }
        &.active {
          color: #171717;
          position: relative;
          &::after {
            content: '';
            display: inline-block;
            position: absolute;
            bottom: 0;
            width: 40px;
            left: 50%;
            height: 10px;
            background: #06b880;
            -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
            border-radius: 5px;
          }
        }
        .list-img {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
  .auth-container {
    position: relative;
    flex: 1;
    // min-height: calc(100vh - 260px);
    // padding: 56px 50px 0px 50px;
  }
  @media screen and (min-width: 1681px) {
    .auth-container {
      // padding: 56px 210px 0px 210px;
    }
  }
}
</style>